/** @format */

import {ReactNode} from 'react';

import {Button, SxProps} from '@mui/material';

import {DropdownButtonRoot as Root} from './style';

export type DropdownButtonVariant = 'primary' | 'secondary' | 'red';

interface Props {
  children: ReactNode;
  variant?: DropdownButtonVariant;
  disabled?: boolean;
  onClick: () => void;
  testId?: string;
  sx?: SxProps;
}

const DropdownButton = ({
  children,
  variant = 'primary',
  disabled = false,
  onClick,
  testId,
  sx,
}: Props) => {
  return (
    <Root variant={variant} disabled={disabled} sx={sx}>
      <Button disabled={disabled} onClick={onClick} {...(testId && {'data-testid': testId})}>
        {children}
      </Button>
    </Root>
  );
};

export default DropdownButton;
